import { render, staticRenderFns } from "./PageIntro.vue?vue&type=template&id=17f86ae4&scoped=true"
import script from "./PageIntro.vue?vue&type=script&lang=js"
export * from "./PageIntro.vue?vue&type=script&lang=js"
import style0 from "./PageIntro.vue?vue&type=style&index=0&id=17f86ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f86ae4",
  null
  
)

export default component.exports